import { Button } from '@mui/material'
import axios from 'axios'
import React from 'react'

const SeedData = () => {
    let seedData =async ()=>{
        await axios.post("https://api.udaymotors.in/api/v1/user/",{
            "phone_no": "7874767358",
            "email": "jay@humbingo.com",
            "password": "Welcome@1",
            "full_name": "Jay Patel"
        }).then(
            (response)=>{
                console.log("User Created! ", response);
            }
        ).catch((err)=>{
            console.log("User Creation Failed");
        });
    }
  return (
    <div><Button onClick={seedData()}>Seed Data</Button></div>
  )
}

export default SeedData